export class RuleError {
    type: string;
    prompt: string;
}
  